import { render } from "./orders.vue?vue&type=template&id=02e1dd7a&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=02e1dd7a&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e1dd7a"]])

export default __exports__